<template>
  <div id="landing-root">

    <!-- NAV -->
    <nav>
      <a class="nav-logo" href="#">
        <img :src="require('@/assets/logo_rombo.png')" alt="Pivot Fleet" style="width:44px;height:44px;object-fit:contain;">
        <span class="nav-logo-text">PIVOT FLEET</span>
      </a>
      <div class="nav-links">
        <a href="#porque">¿Por qué Pivot Fleet?</a>
        <a href="#plataforma">Plataforma</a>
        <a href="#funcionalidades">Funcionalidades</a>
      </div>
      <div class="nav-right">
        <router-link class="nav-login" :to="{ name: 'Login' }">Iniciar sesión</router-link>
        <!-- <a class="nav-cta" href="#" @click.prevent="openDemo">Solicitar Demo</a> -->
      </div>
    </nav>

    <!-- HERO -->
    <div class="hero">
      <h1>¿Sabes dónde está cada vehículo de tu flota en este momento?</h1>
      <p>Pivot Fleet te da el control total de tus vehículos — movimientos, cesiones y costes ocultos — en tiempo real, desde cualquier dispositivo.</p>
      <a class="hero-btn" href="#" @click.prevent="openDemo">Solicita una Demo →</a>

      <div class="cars-scene">
        <div class="car-card">
          <div class="car-label">Tienda A</div>
          <svg viewBox="0 0 110 70" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="55" cy="67" rx="36" ry="4" fill="rgba(0,0,0,0.2)"/>
            <rect x="6" y="32" width="98" height="26" rx="10" fill="#2ECC71"/>
            <path d="M20 32 C22 18,34 12,55 12 C76 12,88 18,90 32 Z" fill="#27AE60"/>
            <path d="M24 31 C25 20,32 14,40 14 L40 31 Z" fill="rgba(120,200,255,0.55)"/>
            <rect x="47" y="14" width="16" height="17" rx="3" fill="rgba(120,200,255,0.55)"/>
            <path d="M86 31 C85 20,78 14,70 14 L70 31 Z" fill="rgba(120,200,255,0.55)"/>
            <rect x="94" y="34" width="9" height="6" rx="3" fill="#FEF08A" opacity="0.95"/>
            <rect x="7" y="34" width="9" height="6" rx="3" fill="#FCA5A5" opacity="0.9"/>
            <circle cx="28" cy="58" r="11" fill="#1E293B"/><circle cx="28" cy="58" r="7" fill="#334155"/><circle cx="28" cy="58" r="3" fill="#94A3B8"/>
            <circle cx="80" cy="58" r="11" fill="#1E293B"/><circle cx="80" cy="58" r="7" fill="#334155"/><circle cx="80" cy="58" r="3" fill="#94A3B8"/>
          </svg>
          <div class="car-plate">1234 ABC</div>
          <div class="car-status s-green">Disponible</div>
        </div>
        <div class="arrow-wrap">
          <svg viewBox="0 0 60 20" fill="none">
            <line x1="0" y1="10" x2="48" y2="10" stroke="rgba(74,222,128,0.8)" stroke-width="2.5" stroke-dasharray="6 4"><animate attributeName="stroke-dashoffset" from="0" to="-20" dur="1.1s" repeatCount="indefinite"/></line>
            <polygon points="45,5 59,10 45,15" fill="rgba(74,222,128,0.8)"/>
          </svg>
        </div>
        <div class="car-card">
          <div class="car-label" style="color:rgba(221,214,254,0.9)">Traslado</div>
          <svg viewBox="0 0 110 70" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="55" cy="67" rx="36" ry="4" fill="rgba(0,0,0,0.2)"/>
            <rect x="6" y="32" width="98" height="26" rx="10" fill="#2ECC71"/>
            <path d="M20 32 C22 18,34 12,55 12 C76 12,88 18,90 32 Z" fill="#27AE60"/>
            <path d="M24 31 C25 20,32 14,40 14 L40 31 Z" fill="rgba(120,200,255,0.55)"/>
            <rect x="47" y="14" width="16" height="17" rx="3" fill="rgba(120,200,255,0.55)"/>
            <path d="M86 31 C85 20,78 14,70 14 L70 31 Z" fill="rgba(120,200,255,0.55)"/>
            <rect x="94" y="34" width="9" height="6" rx="3" fill="#FEF08A" opacity="0.95"/>
            <rect x="7" y="34" width="9" height="6" rx="3" fill="#FCA5A5" opacity="0.9"/>
            <circle cx="28" cy="58" r="11" fill="#1E293B"/><circle cx="28" cy="58" r="7" fill="#334155"/><circle cx="28" cy="58" r="3" fill="#94A3B8"/>
            <circle cx="80" cy="58" r="11" fill="#1E293B"/><circle cx="80" cy="58" r="7" fill="#334155"/><circle cx="80" cy="58" r="3" fill="#94A3B8"/>
            <line x1="0" y1="40" x2="12" y2="40" stroke="rgba(196,181,253,0.8)" stroke-width="2" stroke-linecap="round"/>
            <line x1="0" y1="47" x2="10" y2="47" stroke="rgba(196,181,253,0.5)" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <div class="car-plate">1234 ABC</div>
          <div class="car-status s-purple">En movimiento</div>
        </div>
        <div class="arrow-wrap">
          <svg viewBox="0 0 60 20" fill="none">
            <line x1="0" y1="10" x2="48" y2="10" stroke="rgba(74,222,128,0.8)" stroke-width="2.5" stroke-dasharray="6 4"><animate attributeName="stroke-dashoffset" from="0" to="-20" dur="1.1s" repeatCount="indefinite" begin="0.55s"/></line>
            <polygon points="45,5 59,10 45,15" fill="rgba(74,222,128,0.8)"/>
          </svg>
        </div>
        <div class="car-card">
          <div class="car-label">Tienda B</div>
          <svg viewBox="0 0 110 70" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="55" cy="67" rx="36" ry="4" fill="rgba(0,0,0,0.2)"/>
            <rect x="6" y="32" width="98" height="26" rx="10" fill="#2ECC71"/>
            <path d="M20 32 C22 18,34 12,55 12 C76 12,88 18,90 32 Z" fill="#27AE60"/>
            <path d="M24 31 C25 20,32 14,40 14 L40 31 Z" fill="rgba(120,200,255,0.55)"/>
            <rect x="47" y="14" width="16" height="17" rx="3" fill="rgba(120,200,255,0.55)"/>
            <path d="M86 31 C85 20,78 14,70 14 L70 31 Z" fill="rgba(120,200,255,0.55)"/>
            <rect x="94" y="34" width="9" height="6" rx="3" fill="#FEF08A" opacity="0.95"/>
            <rect x="7" y="34" width="9" height="6" rx="3" fill="#FCA5A5" opacity="0.9"/>
            <circle cx="28" cy="58" r="11" fill="#1E293B"/><circle cx="28" cy="58" r="7" fill="#334155"/><circle cx="28" cy="58" r="3" fill="#94A3B8"/>
            <circle cx="80" cy="58" r="11" fill="#1E293B"/><circle cx="80" cy="58" r="7" fill="#334155"/><circle cx="80" cy="58" r="3" fill="#94A3B8"/>
          </svg>
          <div class="car-plate">1234 ABC</div>
          <div class="car-status s-green">Disponible</div>
        </div>
      </div>
    </div>

    <!-- COMPARE -->
    <section class="compare-section">
      <div class="section-center">
        <div class="section-title anim-fade-up">¿Te suena alguna de estas situaciones?</div>
      </div>
      <div class="compare-grid" style="max-width:900px;margin:1.5rem auto 0;">
        <div class="compare-col bad anim-fade-up">
          <h3>✗ Problemas Actuales</h3>
          <div class="compare-item"><span class="ico-x">✗</span><span>Llamas a tres personas para saber <strong>dónde está un coche</strong></span></div>
          <div class="compare-item"><span class="ico-x">✗</span><span>Un vehículo aparece dañado y <strong>nadie sabe quién fue</strong></span></div>
          <div class="compare-item"><span class="ico-x">✗</span><span>Las multas llegan y <strong>no puedes identificar al responsable</strong></span></div>
          <div class="compare-item"><span class="ico-x">✗</span><span>Los comodatos se firman <strong>en papel y se pierden</strong></span></div>
          <div class="compare-item"><span class="ico-x">✗</span><span>El taller no sabe <strong>en qué estado está cada vehículo</strong></span></div>
          <div class="compare-item"><span class="ico-x">✗</span><span>Cada traslado requiere <strong>llamadas, correos y excels</strong></span></div>
        </div>
        <div class="compare-col good anim-fade-up delay-2">
          <h3>✓ Con Pivot Fleet</h3>
          <div class="compare-item"><span class="ico-check">✓</span><span>Ubicación y estado de cada vehículo <strong>actualizado en tiempo real</strong></span></div>
          <div class="compare-item"><span class="ico-check">✓</span><span>Cada movimiento tiene un <strong>responsable identificado</strong></span></div>
          <div class="compare-item"><span class="ico-check">✓</span><span>Las multas e incidencias quedan <strong>vinculadas al conductor</strong></span></div>
          <div class="compare-item"><span class="ico-check">✓</span><span>Comodatos digitales firmados <strong>desde el móvil en segundos</strong></span></div>
          <div class="compare-item"><span class="ico-check">✓</span><span>Panel de taller con estados <strong>personalizables por proceso</strong></span></div>
          <div class="compare-item"><span class="ico-check">✓</span><span>Un solo sistema para <strong>solicitar, registrar y confirmar traslados</strong></span></div>
        </div>
      </div>
    </section>

    <!-- WHY -->
    <section class="why-section" id="porque">
      <div class="section-center">
        <div class="section-label anim-fade-up">Por qué elegirnos</div>
        <div class="section-title anim-fade-up delay-1">¿Por qué elegir <span>Pivot Fleet</span>?</div>
        <div class="section-sub anim-fade-up delay-2">Todo lo que necesitas para gestionar tu flota en un solo lugar</div>
        <div class="cards-grid">
          <div class="why-card anim-fade-up">
            <div class="why-icon">📍</div>
            <h3>0 vehículos perdidos</h3>
            <p>Sabes dónde está cada vehículo, quién lo movió y cuándo. En tiempo real.</p>
          </div>
          <div class="why-card anim-fade-up delay-1">
            <div class="why-icon">📄</div>
            <h3>Adiós al papel y los excels</h3>
            <p>Comodatos y cesiones firmados desde el móvil en segundos. Sin imprimir nada.</p>
          </div>
          <div class="why-card anim-fade-up delay-2">
            <div class="why-icon">⏱️</div>
            <h3>-80% de gestiones manuales</h3>
            <p>Sin llamadas para localizar vehículos — sin correos, sin excels.</p>
          </div>
          <div class="why-card anim-fade-up delay-3">
            <div class="why-icon">💰</div>
            <h3>Recupera dinero sin saberlo</h3>
            <p>Cada multa y daño, vinculado a un responsable al instante.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- VIDEO -->
    <section style="background:linear-gradient(180deg,#1E5CD6 0%,#F0F4FA 100%);padding:0;overflow:hidden;">
      <div style="background:linear-gradient(180deg,#1E5CD6 0%,#1a54c8 100%);height:60px;"></div>
      <div style="background:#F0F4FA;padding:3rem 1.5rem 4rem;">
        <div style="max-width:860px;margin:0 auto;text-align:center;">
          <div style="display:inline-block;background:rgba(46,134,232,0.1);color:#2E86E8;font-size:0.7rem;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;padding:4px 14px;border-radius:50px;border:1px solid rgba(46,134,232,0.2);margin-bottom:1rem;">La plataforma en acción</div>
          <h2 style="font-size:clamp(1.5rem,4vw,2.4rem);font-weight:800;color:#0D2B6B;margin-bottom:0.75rem;letter-spacing:-0.02em;">Descubre cómo funciona <span style="color:#2E86E8">Pivot Fleet</span></h2>
          <p style="font-size:0.9rem;color:#6B84B0;margin-bottom:2rem;">Trazabilidad, cesiones y control de stock — todo en una sola plataforma.</p>
          <div style="position:relative;border-radius:20px;overflow:hidden;box-shadow:0 25px 60px rgba(13,43,107,0.18);background:#000;padding-top:56.25%;">
            <iframe src="https://www.youtube.com/embed/baVNnFGTY6U?rel=0&modestbranding=1&color=white&controls=1"
              title="Pivot Fleet — Presentación de la plataforma" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;border-radius:20px;"></iframe>
          </div>
          <div style="margin-top:2rem;display:flex;gap:1rem;justify-content:center;flex-wrap:wrap;">
            <a href="#" @click.prevent="openDemo" style="background:#2ECC71;color:#fff;text-decoration:none;padding:0.8rem 1.8rem;border-radius:50px;font-weight:700;font-size:0.9rem;box-shadow:0 6px 20px rgba(46,204,113,0.35);">Solicitar Demo →</a>
            <a href="#funcionalidades" style="background:transparent;color:#2E86E8;text-decoration:none;padding:0.8rem 1.8rem;border-radius:50px;font-weight:600;font-size:0.9rem;border:1.5px solid #2E86E8;">Ver funcionalidades ↓</a>
          </div>
        </div>
      </div>
    </section>

    <!-- MOCKUP -->
    <section class="mockup-section" id="plataforma">
      <div class="mockup-inner">
        <div class="mockup-text anim-fade-up">
          <h2>Diseñado para ser <span>intuitivo</span> y potente</h2>
          <p>Una sola plataforma para controlar todos los movimientos, cesiones y estados de tu flota — en tiempo real, desde cualquier dispositivo.</p>
          <div style="margin-top:1rem;">
            <div class="check-item">Petición de movimiento con notificación automática al responsable</div>
            <div class="check-item">Cesiones a cliente con comodato digital y firma en móvil</div>
            <div class="check-item">Historial completo de ubicaciones y procesos por vehículo</div>
            <div class="check-item">Estados en tiempo real: Recepcionado, En movimiento, En cesión</div>
            <div class="check-item">Entrega y recepción del vehículo registrada directamente desde el dispositivo móvil</div>
          </div>
        </div>
        <div class="browser anim-fade-up delay-2">
          <div class="browser-bar">
            <div class="b-dot" style="background:#FF5F57"></div>
            <div class="b-dot" style="background:#FFBD2E"></div>
            <div class="b-dot" style="background:#28C840"></div>
            <div class="b-url">pivotfleet.com</div>
          </div>
          <div class="app-layout">
            <!-- SIDEBAR -->
            <div class="sidebar" style="display:flex!important;flex-direction:column!important;width:40px!important;min-width:40px!important;flex-shrink:0!important;">
              <div class="s-icon" style="background:rgba(255,255,255,0.9);border-radius:50%;padding:2px;width:24px;height:24px;">
                <img :src="require('@/assets/logo_rombo.png')" alt="" style="width:18px;height:18px;object-fit:contain;display:block;">
              </div>
              <div class="s-icon active">🚗</div>
              <div class="s-icon">🚐</div>
              <div class="s-icon">↔️</div>
              <div class="s-icon">🔔</div>
              <div class="s-icon">📋</div>
              <div class="s-icon">👥</div>
              <div class="s-icon">🚙</div>
              <div class="s-icon">👤</div>
              <div class="s-icon">📍</div>
              <div class="s-icon">⚙️</div>
            </div>
            <!-- MAIN CONTENT -->
            <div class="app-main" style="flex:1;min-width:0;overflow:hidden;">
              <div class="topbar">
                <img :src="require('@/assets/logo_rombo.png')" alt="" style="width:22px;height:22px;object-fit:contain;flex-shrink:0;">
                <div class="topbar-right">
                  <div class="topbar-txt">🔔 MANUAL</div>
                </div>
              </div>
              <!-- STATS -->
              <div class="stats-row" style="display:flex;gap:3px;padding:5px 6px;flex-wrap:nowrap;overflow:hidden;">
                <div class="stat-card"><span class="stat-num" style="color:#2E86E8">857</span><span class="stat-lbl">Total</span></div>
                <div class="stat-card"><span class="stat-num" style="color:#D97706">109</span><span class="stat-lbl">Pendientes</span></div>
                <div class="stat-card"><span class="stat-num" style="color:#2E86E8">738</span><span class="stat-lbl">Creados</span></div>
                <div class="stat-card"><span class="stat-num" style="color:#059669">9</span><span class="stat-lbl">Recepcionados</span></div>
                <div class="stat-card"><span class="stat-num" style="color:#7C3AED">1</span><span class="stat-lbl">En movimiento</span></div>
                <div class="stat-card"><span class="stat-num" style="color:#475569">0</span><span class="stat-lbl">Archivado</span></div>
                <div class="stat-card"><span class="stat-num" style="color:#2E86E8">857</span><span class="stat-lbl">Este mes</span></div>
              </div>
              <!-- TABLE -->
              <div class="table-wrap" style="padding:0 6px 6px;">
                <div class="table-header" style="background:var(--blue-light);border-radius:6px 6px 0 0;padding:5px 8px;display:flex;align-items:center;gap:5px;">
                  <span class="table-title">Vehículos</span>
                  <div class="search-bar">🔍 Buscar...</div>
                </div>
                <div class="filters" style="background:#fff;padding:4px 6px;display:flex;gap:3px;flex-wrap:wrap;border:1px solid #E2ECF8;border-top:none;border-bottom:none;">
                  <span class="filter-pill fp-orange">Pendientes</span>
                  <span class="filter-pill fp-blue">Creados</span>
                  <span class="filter-pill fp-green">✓ Recepcionados</span>
                  <span class="filter-pill fp-purple">En movimiento</span>
                  <span class="filter-pill fp-gray">Archivado</span>
                </div>
                <table style="width:100%;border-collapse:collapse;background:#fff;border:1px solid #E2ECF8;border-top:none;table-layout:fixed;">
                  <colgroup>
                    <col style="width:9%">
                    <col style="width:22%">
                    <col style="width:14%">
                    <col style="width:16%">
                    <col style="width:20%">
                    <col style="width:19%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th style="font-size:0.4rem;font-weight:700;color:#94A3B8;padding:3px 4px;text-align:left;border-bottom:1px solid #E2ECF8;background:#F8FAFC;text-transform:uppercase;">Cond</th>
                      <th style="font-size:0.4rem;font-weight:700;color:#94A3B8;padding:3px 4px;text-align:left;border-bottom:1px solid #E2ECF8;background:#F8FAFC;text-transform:uppercase;">Vehículo</th>
                      <th style="font-size:0.4rem;font-weight:700;color:#94A3B8;padding:3px 4px;text-align:left;border-bottom:1px solid #E2ECF8;background:#F8FAFC;text-transform:uppercase;">Matr.</th>
                      <th style="font-size:0.4rem;font-weight:700;color:#94A3B8;padding:3px 4px;text-align:left;border-bottom:1px solid #E2ECF8;background:#F8FAFC;text-transform:uppercase;">Ubic.</th>
                      <th style="font-size:0.4rem;font-weight:700;color:#94A3B8;padding:3px 4px;text-align:left;border-bottom:1px solid #E2ECF8;background:#F8FAFC;text-transform:uppercase;">Proceso</th>
                      <th style="font-size:0.4rem;font-weight:700;color:#94A3B8;padding:3px 4px;text-align:left;border-bottom:1px solid #E2ECF8;background:#F8FAFC;text-transform:uppercase;">Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><span class="cond-vn">VN</span></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><div class="veh-name">KIA XCeed PHEV</div><div class="veh-sub">eDrive</div></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><span class="mat-badge">0868NCW</span></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><div class="loc-txt">📍 Tienda A</div></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><span class="sb sb-gray">Sin estado</span></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><span class="sb sb-purple">En movimiento</span></td>
                    </tr>
                    <tr>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><span class="cond-vn">VN</span></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><div class="veh-name">Honda Civic</div><div class="veh-sub">TYPE R</div></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><span class="mat-badge">7635KKK</span></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><div class="loc-txt">📍 T. Plancha</div></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><span class="sb sb-orange">Pend. Peritaje</span></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><span class="sb sb-green">Recepcionado</span></td>
                    </tr>
                    <tr>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><span class="cond-vn">VN</span></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><div class="veh-name">KIA EV4 Earth</div><div class="veh-sub">Long Range</div></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><span class="mat-badge">50481</span></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><div class="loc-txt">📍 T. Mecánica</div></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><span class="sb sb-red">En reparación</span></td>
                      <td style="padding:4px;border-bottom:1px solid #F1F5F9;"><span class="sb sb-green">Recepcionado</span></td>
                    </tr>
                    <tr>
                      <td style="padding:4px;"><span class="cond-vo">VO</span></td>
                      <td style="padding:4px;"><div class="veh-name">KIA XCeed PHEV</div><div class="veh-sub">eDrive</div></td>
                      <td style="padding:4px;"><span class="mat-badge">4993MTB</span></td>
                      <td style="padding:4px;"><div class="loc-txt">📍 Tienda B</div></td>
                      <td style="padding:4px;"><span class="sb sb-gray">Sin estado</span></td>
                      <td style="padding:4px;"><span class="sb sb-blue">En cesión</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FEATURES -->
    <section class="features-section" id="funcionalidades">
      <div class="section-center anim-fade-up">
        <div class="section-label">Funcionalidades</div>
        <div class="section-title">Todas las funcionalidades que necesitas</div>
        <div class="section-sub">Una plataforma completa para gestionar cada aspecto de tu flota</div>
      </div>
      <div class="features-list" style="max-width:960px;margin-left:auto;margin-right:auto;">
        <div class="feat-item anim-fade-up">
          <div class="feat-icon-wrap">📍</div>
          <div><h4>Trazabilidad de movimientos</h4><p>Traslados entre tiendas por conductor o grúa, con stock ubicado en tiempo real.</p></div>
        </div>
        <div class="feat-item anim-fade-up delay-1">
          <div class="feat-icon-wrap">📄</div>
          <div><h4>Comodatos digitales</h4><p>Crea, firma y gestiona cesiones de forma completamente digital. Sin papel.</p></div>
        </div>
        <div class="feat-item anim-fade-up delay-2">
          <div class="feat-icon-wrap">🔧</div>
          <div><h4>Panel de seguimiento</h4><p>Seguimiento de estados en mecánica, carrocería, limpieza. Personalizable por cliente.</p></div>
        </div>
        <div class="feat-item anim-fade-up">
          <div class="feat-icon-wrap">📷</div>
          <div><h4>Reporte de daños</h4><p>Documenta incidencias con fotos, comentarios y archivos adjuntos. Historial completo.</p></div>
        </div>
        <div class="feat-item anim-fade-up delay-1">
          <div class="feat-icon-wrap">🚨</div>
          <div><h4>Gestión de multas</h4><p>Control y trazabilidad de multas por vehículo. Identifica responsables y evita cargos inesperados.</p></div>
        </div>
        <div class="feat-item anim-fade-up delay-2">
          <div class="feat-icon-wrap">📊</div>
          <div><h4>Reportes y analíticas</h4><p>Datos de actividad, costes e incidencias para tomar decisiones estratégicas.</p></div>
        </div>
      </div>
    </section>

    <!-- TESTIMONIALS -->
    <section class="testi-section">
      <div class="section-center">
        <div class="section-label anim-fade-up">Clientes</div>
        <div class="section-title anim-fade-up delay-1">Lo que dicen nuestros clientes</div>
        <div class="section-sub anim-fade-up delay-2">Concesionarios que ya confían en Pivot Fleet</div>
        <div class="testi-grid">
          <div class="testi-card anim-fade-up">
            <div class="testi-stars">★★★★★</div>
            <div class="testi-quote">"Antes llamaba a tres personas para saber dónde estaba un vehículo. Ahora abro Pivot Fleet y lo veo en segundos — ubicación, conductor y estado."</div>
            <div class="testi-footer">
              <div class="testi-avatar">CA</div>
              <div>
                <div class="testi-author">Carlos</div>
                <div class="testi-role">Jefe de Ventas</div>
              </div>
            </div>
          </div>
          <div class="testi-card anim-fade-up delay-1">
            <div class="testi-stars">★★★★☆</div>
            <div class="testi-quote">"Hemos reducido los mails internos a la mitad. Todo lo que antes gestionábamos por correo y excel ahora queda registrado automáticamente."</div>
            <div class="testi-footer">
              <div class="testi-avatar">LA</div>
              <div>
                <div class="testi-author">Laura</div>
                <div class="testi-role">Dep. Logística</div>
              </div>
            </div>
          </div>
          <div class="testi-card anim-fade-up delay-2">
            <div class="testi-stars">★★★★★</div>
            <div class="testi-quote">"Por fin tengo visibilidad real del stock. Antes dependía de que alguien me lo dijera. Ahora lo consulto yo directamente cuando quiero."</div>
            <div class="testi-footer">
              <div class="testi-avatar">MA</div>
              <div>
                <div class="testi-author">Marta</div>
                <div class="testi-role">Gerente</div>
              </div>
            </div>
          </div>
          <div class="testi-card anim-fade-up">
            <div class="testi-stars">★★★★★</div>
            <div class="testi-quote">"La entrega y recepción desde el móvil es un cambio enorme. El cliente firma en el momento y no tenemos que reportar nada a nadie después."</div>
            <div class="testi-footer">
              <div class="testi-avatar">JO</div>
              <div>
                <div class="testi-author">Jordi</div>
                <div class="testi-role">Vendedor</div>
              </div>
            </div>
          </div>
          <div class="testi-card anim-fade-up delay-1">
            <div class="testi-stars">★★★★☆</div>
            <div class="testi-quote">"Ahora sabemos en qué estado está cada vehículo dentro del taller, cuándo entró en cada fase y quién hizo el cambio. Antes eso era imposible de rastrear."</div>
            <div class="testi-footer">
              <div class="testi-avatar">AN</div>
              <div>
                <div class="testi-author">Ana</div>
                <div class="testi-role">Responsable de Taller</div>
              </div>
            </div>
          </div>
          <div class="testi-card anim-fade-up delay-2">
            <div class="testi-stars">★★★★★</div>
            <div class="testi-quote">"Lo que más me sorprendió fue lo rápido que lo adoptó el equipo. En menos de una semana todo el mundo lo usaba sin formación específica."</div>
            <div class="testi-footer">
              <div class="testi-avatar">SE</div>
              <div>
                <div class="testi-author">Sergio</div>
                <div class="testi-role">Director de Operaciones</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FOR WHO SECTION -->
    <section class="forwho-section">
      <div class="section-center">
        <div class="section-label anim-fade-up">¿Es para mí?</div>
        <div class="section-title anim-fade-up delay-1">Pivot Fleet es para ti si gestionas vehículos</div>
        <div class="section-sub anim-fade-up delay-2">Si en tu empresa los coches se mueven, se ceden o se gestionan — tienes un problema que Pivot Fleet ya resuelve.</div>
        <div class="forwho-highlight anim-fade-up delay-3">
          Aquello que siempre has necesitado y nadie te lo había ofrecido.
        </div>
      </div>
      <div class="forwho-grid" style="max-width:1000px;margin:2rem auto 0;">
        <div class="forwho-card anim-fade-up">
          <h4>Grupos de concesionarios</h4>
          <p>Múltiples tiendas, un solo panel. Controla el stock de toda la red en tiempo real sin llamadas.</p>
        </div>
        <div class="forwho-card anim-fade-up delay-1">
          <h4>Concesionarios multimarca</h4>
          <p>Vehículos de distintas marcas, un único sistema de trazabilidad. Sin excels por marca.</p>
        </div>
        <div class="forwho-card anim-fade-up delay-2">
          <h4>Marcas y flotas corporativas</h4>
          <p>Vehículos de prensa, empleados y cortesía. Control total de quién lo tiene, desde cuándo y en qué estado.</p>
        </div>
        <div class="forwho-card anim-fade-up">
          <h4>Flotas de sustitución</h4>
          <p>Vehículos de cortesía siempre localizados. Comodato digital firmado desde el móvil.</p>
        </div>
        <div class="forwho-card anim-fade-up delay-1">
          <h4>Empresas de renting y leasing</h4>
          <p>Cesiones, devoluciones y estado de cada vehículo. Sin llamadas. Sin excels.</p>
        </div>
        <div class="forwho-card anim-fade-up delay-2">
          <h4>Talleres y redes de postventa</h4>
          <p>Seguimiento del estado en taller — quién cambió cada estado y cuándo. Sin pérdidas de información.</p>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <div class="cta-final" id="demo">
      <h2 class="anim-fade-up">Lleva tu gestión de flota al siguiente nivel</h2>
      <p class="anim-fade-up delay-1">Descubre cómo Pivot Fleet puede transformar tu operación en minutos</p>
      <a class="hero-btn anim-fade-up delay-2" href="#" @click.prevent="openDemo">Agenda tu Demo Gratuita →</a>
    </div>

    <!-- FOOTER -->
    <footer>
      <div class="foot-logo">
        <img :src="require('@/assets/logo_rombo.png')" alt="Pivot Fleet" style="width:30px;height:30px;object-fit:contain;">
        PIVOT FLEET
      </div>
      <div class="foot-copy"> © {{ new Date().getFullYear() }} Pivot Fleet. Todos los derechos reservados.</div>
    </footer>

  </div>
</template>

<script>
export default {
  name: 'Landing',
  data () {
    return {
      copiedToast: false
    }
  },
  computed: {
    demoMailto () {
      const subject = 'Solicitud de Demo - Pivot Fleet'
      const body = [
        'Hola, equipo de Pivot Fleet,',
        '',
        'Somos [Nombre de la empresa] y nos gustar\u00eda solicitar una demostraci\u00f3n de vuestra plataforma.',
        '',
        'Estamos interesados en conocer c\u00f3mo Pivot Fleet puede ayudarnos a mejorar el control, la trazabilidad y la gesti\u00f3n de nuestros veh\u00edculos, as\u00ed como descubrir las funcionalidades que mejor se adapten a nuestras necesidades.',
        '',
        'Pod\u00e9is contactar con nosotros a trav\u00e9s de los siguientes datos:',
        '',
        '* Nombre: [Nombre y apellidos]',
        '* Cargo: [Cargo]',
        '* Empresa: [Nombre de la empresa]',
        '* Tel\u00e9fono: [Tel\u00e9fono]',
        '* Correo electr\u00f3nico: [Email]',
        '',
        'Quedamos a la espera de vuestra respuesta para concertar una reuni\u00f3n.',
        '',
        'Muchas gracias.'
      ].join('\r\n')
      return `mailto:notificaciones@pivotfleet.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
    }
  },
  methods: {
    openDemo () {
      this.copiedToast = true
      setTimeout(() => { this.copiedToast = false }, 8000)

      const a = document.createElement('a')
      a.href = this.demoMailto
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  },
  mounted () {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    )
    this.$el.querySelectorAll('.anim-fade-up').forEach(el => observer.observe(el))
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

#landing-root *,
#landing-root *::before,
#landing-root *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
#landing-root {
  max-width: 100%;
  overflow-x: hidden;
  font-family: 'Inter', sans-serif;
  background: #fff;
}
#landing-root img { max-width: 100%; display: block; }
#landing-root { scroll-behavior: smooth; }

:root {
  --blue-dark: #0F3390;
  --blue-mid: #1E5CD6;
  --blue-light: #2E86E8;
  --green: #2ECC71;
  --green-dark: #27AE60;
  --gray-bg: #F0F4FA;
  --gray-light: #E8EEF8;
  --navy: #0D2B6B;
  --text-dark: #0D2B6B;
  --text-mid: #2D4A7A;
  --text-muted: #6B84B0;
  --red: #E53E3E;
  --red-bg: #FFF0F0;
  --green-bg: #F0FFF6;
}

/* NAV */
#landing-root nav {
  background: var(--blue-dark);
  padding: 0.8rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
}
#landing-root .nav-logo { display: flex; align-items: center; gap: 10px; text-decoration: none; flex-shrink: 0; }
#landing-root .nav-logo-text { font-size: 1.05rem; font-weight: 900; color: #fff; letter-spacing: 0.08em; white-space: nowrap; }
#landing-root .nav-links { display: flex; gap: 1.5rem; }
#landing-root .nav-links a { color: rgba(255,255,255,0.75); text-decoration: none; font-size: 0.85rem; white-space: nowrap; }
#landing-root .nav-links a:hover { color: #fff; }
#landing-root .nav-right { display: flex; align-items: center; gap: 0.75rem; flex-shrink: 0; }
#landing-root .nav-login { color: rgba(255,255,255,0.9); text-decoration: none; font-size: 0.82rem; font-weight: 600; border: 1.5px solid rgba(255,255,255,0.35); padding: 0.4rem 1rem; border-radius: 50px; white-space: nowrap; }
#landing-root .nav-cta { background: var(--green); color: #fff; border: none; padding: 0.45rem 1.1rem; border-radius: 50px; font-weight: 700; font-size: 0.82rem; cursor: pointer; text-decoration: none; white-space: nowrap; }

/* HERO */
#landing-root .hero {
  background: linear-gradient(135deg, var(--blue-dark) 0%, var(--blue-mid) 50%, var(--blue-light) 100%);
  padding: 4rem 1.5rem 2.5rem;
  text-align: center;
  width: 100%;
  overflow: hidden;
}
#landing-root .hero h1 { font-size: clamp(1.7rem,5vw,3.2rem); font-weight: 900; color: #fff; line-height: 1.1; letter-spacing: -0.02em; max-width: 820px; margin: 0 auto 1rem; }
#landing-root .hero p { font-size: clamp(0.9rem,2.5vw,1.05rem); color: rgba(255,255,255,0.8); max-width: 520px; margin: 0 auto 1.8rem; line-height: 1.6; }
#landing-root .hero-btn { background: var(--green); color: #fff; border: none; padding: 0.9rem 2rem; border-radius: 50px; font-size: 0.95rem; font-weight: 700; cursor: pointer; box-shadow: 0 6px 24px rgba(46,204,113,0.4); display: inline-block; text-decoration: none; }

/* CARS SCENE */
#landing-root .cars-scene { margin-top: 2.5rem; display: flex; align-items: center; justify-content: center; gap: 0; width: 100%; padding: 0 0.5rem; }
#landing-root .car-card { background: rgba(255,255,255,0.13); border: 1.5px solid rgba(255,255,255,0.25); border-radius: 16px; padding: 1rem 0.8rem; display: flex; flex-direction: column; align-items: center; gap: 0.5rem; flex: 1; max-width: 160px; min-width: 0; animation: floatCard 3s ease-in-out infinite; }
#landing-root .car-card:nth-child(3) { animation-delay: 0.4s; border-color: rgba(167,139,250,0.7); background: rgba(109,40,217,0.18); }
#landing-root .car-card:nth-child(5) { animation-delay: 0.8s; }
@keyframes floatCard { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
#landing-root .car-card svg { width: 100%; max-width: 90px; height: auto; }
#landing-root .car-label { font-size: 0.6rem; font-weight: 700; color: rgba(255,255,255,0.7); letter-spacing: 0.08em; text-transform: uppercase; }
#landing-root .car-plate { background: rgba(255,255,255,0.18); color: #fff; font-weight: 700; font-size: 0.72rem; padding: 2px 8px; border-radius: 5px; }
#landing-root .car-status { font-size: 0.62rem; font-weight: 700; padding: 2px 8px; border-radius: 50px; }
#landing-root .s-green { background: rgba(46,204,113,0.3); color: #4ADE80; border: 1.5px solid rgba(74,222,128,0.6); }
#landing-root .s-purple { background: rgba(109,40,217,0.4); color: #DDD6FE; border: 1.5px solid rgba(167,139,250,0.95); }
#landing-root .arrow-wrap { display: flex; align-items: center; padding-bottom: 0.4rem; flex-shrink: 0; margin: 0 2px; }
#landing-root .arrow-wrap svg { width: 40px; height: 20px; }

/* SECTIONS */
#landing-root section { padding: 3.5rem 1.5rem; width: 100%; }
#landing-root .section-center { text-align: center; max-width: 900px; margin: 0 auto; }
#landing-root .section-label { font-size: 0.7rem; font-weight: 700; color: var(--blue-light); letter-spacing: 0.12em; text-transform: uppercase; margin-bottom: 0.5rem; }
#landing-root .section-title { font-size: clamp(1.4rem,4vw,2.4rem); font-weight: 800; color: var(--text-dark); margin-bottom: 0.4rem; letter-spacing: -0.02em; }
#landing-root .section-title span { color: var(--blue-light); }
#landing-root .section-sub { font-size: 0.9rem; color: var(--text-muted); margin-bottom: 2rem; }

/* WHY CARDS */
#landing-root .why-section { background: #fff; }
#landing-root .cards-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 1rem; max-width: 900px; margin: 0 auto; }
#landing-root .why-card { background: #fff; border: 1.5px solid var(--gray-light); border-radius: 18px; padding: 1.8rem 1.2rem; text-align: center; }
#landing-root .why-icon { width: 64px; height: 64px; border-radius: 50%; background: var(--green); display: flex; align-items: center; justify-content: center; margin: 0 auto 1rem; font-size: 1.6rem; box-shadow: 0 6px 20px rgba(46,204,113,0.3); }
#landing-root .why-card h3 { font-size: 0.9rem; font-weight: 800; color: var(--text-dark); margin-bottom: 0.4rem; line-height: 1.3; }
#landing-root .why-card p { font-size: 0.8rem; color: var(--text-muted); line-height: 1.6; }

/* COMPARE */
#landing-root .compare-section { background: var(--gray-bg); }
#landing-root .compare-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 1.2rem; max-width: 900px; margin: 0 auto; }
#landing-root .compare-col { border-radius: 16px; padding: 1.5rem; }
#landing-root .compare-col.bad { background: var(--red-bg); border: 1.5px solid rgba(229,62,62,0.2); }
#landing-root .compare-col.good { background: var(--green-bg); border: 1.5px solid rgba(46,204,113,0.3); }
#landing-root .compare-col h3 { font-size: 1rem; font-weight: 800; margin-bottom: 1rem; }
#landing-root .compare-col.bad h3 { color: var(--red); }
#landing-root .compare-col.good h3 { color: var(--green-dark); }
#landing-root .compare-item { display: flex; gap: 8px; align-items: flex-start; padding: 0.4rem 0; border-bottom: 1px solid rgba(0,0,0,0.05); font-size: 0.82rem; line-height: 1.5; }
#landing-root .compare-item:last-child { border-bottom: none; }
#landing-root .ico-x { color: var(--red); font-weight: 900; min-width: 16px; font-size: 0.9rem; }
#landing-root .ico-check { color: var(--green-dark); font-weight: 900; min-width: 16px; font-size: 0.9rem; }
#landing-root .compare-item span { color: var(--text-mid); }

/* MOCKUP */
#landing-root .mockup-section { background: #fff; }
#landing-root .mockup-inner { max-width: 1100px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1.4fr; gap: 2rem; align-items: start; }
#landing-root .mockup-text h2 { font-size: clamp(1.4rem,3.5vw,2.2rem); font-weight: 800; color: var(--text-dark); line-height: 1.2; margin-bottom: 0.9rem; }
#landing-root .mockup-text h2 span { color: var(--blue-light); }
#landing-root .mockup-text p { font-size: 0.88rem; color: var(--text-muted); line-height: 1.7; margin-bottom: 0.5rem; }
#landing-root .check-item { display: flex; align-items: flex-start; gap: 8px; font-size: 0.84rem; color: var(--text-mid); margin-bottom: 0.4rem; line-height: 1.4; }
#landing-root .check-item::before { content: "✓"; color: var(--green); font-weight: 900; flex-shrink: 0; }

/* BROWSER MOCKUP */
#landing-root .browser { background: #fff; border-radius: 12px; border: 1.5px solid #E2E8F4; box-shadow: 0 20px 50px rgba(13,43,107,0.12); overflow: hidden; width: 100%; max-width: 100%; }
#landing-root .browser-bar { background: #F1F5FB; padding: 7px 10px; display: flex; align-items: center; gap: 5px; border-bottom: 1px solid #E2E8F4; }
#landing-root .b-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
#landing-root .b-url { flex: 1; background: #fff; border: 1px solid #E2E8F4; border-radius: 4px; padding: 2px 7px; font-size: 0.6rem; color: #94A3B8; margin-left: 4px; min-width: 0; }
#landing-root .app-layout { display: flex; width: 100%; overflow: hidden; max-height: 380px; }
#landing-root .sidebar { width: 34px; background: var(--blue-light); display: flex; flex-direction: column; align-items: center; padding: 8px 0; gap: 7px; flex-shrink: 0; }
#landing-root .s-icon { width: 20px; height: 20px; border-radius: 5px; background: rgba(255,255,255,0.15); display: flex; align-items: center; justify-content: center; font-size: 0.6rem; flex-shrink: 0; }
#landing-root .s-icon.active { background: rgba(255,255,255,0.35); }
#landing-root .app-main { flex: 1; min-width: 0; overflow: hidden; background: #F0F5FC; }
#landing-root .topbar { background: var(--blue-light); padding: 5px 8px; display: flex; align-items: center; justify-content: space-between; }
#landing-root .topbar-right { display: flex; align-items: center; gap: 5px; }
#landing-root .topbar-txt { font-size: 0.52rem; color: rgba(255,255,255,0.85); font-weight: 600; }
#landing-root .stats-row { display: flex; gap: 3px; padding: 5px 6px; overflow: hidden; flex-wrap: nowrap; }
#landing-root .stat-card { background: #fff; border-radius: 6px; padding: 4px 3px; flex: 1; min-width: 0; text-align: center; border: 1px solid #E2ECF8; }
#landing-root .stat-num { font-size: 0.72rem; font-weight: 800; display: block; line-height: 1.2; }
#landing-root .stat-lbl { font-size: 0.4rem; color: #94A3B8; display: block; line-height: 1.2; }
#landing-root .table-wrap { padding: 0 6px 6px; }
#landing-root .table-header { background: var(--blue-light); border-radius: 6px 6px 0 0; padding: 4px 7px; display: flex; align-items: center; gap: 4px; }
#landing-root .table-title { font-size: 0.58rem; font-weight: 700; color: #fff; }
#landing-root .search-bar { flex: 1; min-width: 0; background: rgba(255,255,255,0.18); border-radius: 3px; padding: 2px 5px; font-size: 0.5rem; color: rgba(255,255,255,0.65); margin-left: 4px; }
#landing-root .filters { background: #fff; padding: 3px 5px; display: flex; gap: 3px; flex-wrap: wrap; }
#landing-root .filter-pill { font-size: 0.44rem; font-weight: 600; padding: 1px 5px; border-radius: 50px; border: 1px solid; white-space: nowrap; }
#landing-root .fp-orange { color: #D97706; border-color: #FCD34D; background: #FFFBEB; }
#landing-root .fp-blue { color: #1D4ED8; border-color: #93C5FD; background: #EFF6FF; }
#landing-root .fp-green { color: #059669; border-color: #6EE7B7; background: #ECFDF5; }
#landing-root .fp-purple { color: #7C3AED; border-color: #C4B5FD; background: #F5F3FF; }
#landing-root .fp-gray { color: #475569; border-color: #CBD5E1; background: #F8FAFC; }
#landing-root .veh-name { font-weight: 600; font-size: 0.48rem; color: #0D2B6B; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
#landing-root .veh-sub { font-size: 0.4rem; color: #94A3B8; }
#landing-root .mat-badge { font-size: 0.42rem; font-weight: 600; color: #475569; background: #F1F5F9; padding: 1px 3px; border-radius: 2px; }
#landing-root .loc-txt { font-size: 0.44rem; color: #475569; }
#landing-root .sb { font-size: 0.4rem; font-weight: 700; padding: 1px 5px; border-radius: 50px; white-space: nowrap; display: inline-block; }
#landing-root .sb-green { background: #DCFCE7; color: #166534; border: 1px solid #86EFAC; }
#landing-root .sb-blue { background: #DBEAFE; color: #1E40AF; border: 1px solid #93C5FD; }
#landing-root .sb-purple { background: #F3E8FF; color: #6B21A8; border: 1px solid #D8B4FE; }
#landing-root .sb-orange { background: #FEF3C7; color: #92400E; border: 1px solid #FCD34D; }
#landing-root .sb-red { background: #FEE2E2; color: #991B1B; border: 1px solid #FCA5A5; }
#landing-root .sb-gray { background: #F1F5F9; color: #475569; border: 1px solid #CBD5E1; }
#landing-root .cond-vn { background: #DCFCE7; color: #166534; font-size: 0.42rem; font-weight: 700; padding: 1px 3px; border-radius: 2px; }
#landing-root .cond-vo { background: #FEF3C7; color: #92400E; font-size: 0.42rem; font-weight: 700; padding: 1px 3px; border-radius: 2px; }

/* FEATURES */
#landing-root .features-section { background: var(--gray-bg); }
#landing-root .features-list { display: grid; grid-template-columns: repeat(auto-fit,minmax(260px,1fr)); gap: 1.2rem; margin-top: 2rem; }
#landing-root .feat-item { display: flex; gap: 1rem; align-items: flex-start; padding: 1.6rem 1.4rem; border-radius: 16px; border: 1.5px solid var(--gray-light); background: #fff; }
#landing-root .feat-icon-wrap { min-width: 48px; height: 48px; border-radius: 12px; background: linear-gradient(135deg, var(--green), var(--green-dark)); display: flex; align-items: center; justify-content: center; font-size: 1.3rem; flex-shrink: 0; }
#landing-root .feat-item h4 { font-size: 0.95rem; font-weight: 800; color: var(--text-dark); margin-bottom: 0.35rem; }
#landing-root .feat-item p { font-size: 0.83rem; color: var(--text-muted); line-height: 1.55; }

/* TESTIMONIALS */
#landing-root .testi-section { background: var(--gray-bg); }
#landing-root .testi-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.2rem; margin-top: 2rem; }
#landing-root .testi-card { background: #fff; border-radius: 16px; border: 1.5px solid var(--gray-light); padding: 1.5rem; display: flex; flex-direction: column; gap: 0.75rem; text-align: left; }
#landing-root .testi-stars { color: #F59E0B; font-size: 0.85rem; letter-spacing: 2px; }
#landing-root .testi-quote { font-size: 0.86rem; color: var(--text-mid); line-height: 1.7; font-style: italic; flex: 1; }
#landing-root .testi-footer { display: flex; align-items: center; gap: 10px; }
#landing-root .testi-avatar { width: 36px; height: 36px; border-radius: 50%; background: linear-gradient(135deg, var(--blue-light), var(--blue-dark)); display: flex; align-items: center; justify-content: center; font-size: 0.65rem; font-weight: 800; color: #fff; flex-shrink: 0; }
#landing-root .testi-author { font-weight: 700; font-size: 0.83rem; color: var(--text-dark); line-height: 1.2; }
#landing-root .testi-role { font-size: 0.72rem; color: var(--text-muted); line-height: 1.2; margin-top: 2px; }

/* FOR WHO SECTION */
#landing-root .forwho-section { background: var(--gray-bg); padding: 3.5rem 1.5rem 4rem; }
#landing-root .forwho-highlight { font-size: 1.1rem; font-weight: 700; color: var(--blue-light); margin-top: 1.5rem; font-style: italic; }
#landing-root .forwho-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.2rem; }
#landing-root .forwho-card { background: #fff; border: 1.5px solid var(--gray-light); border-radius: 16px; padding: 1.8rem 1.4rem; }
#landing-root .forwho-card h4 { font-size: 1rem; font-weight: 800; color: var(--text-dark); margin-bottom: 0.6rem; line-height: 1.3; }
#landing-root .forwho-card p { font-size: 0.86rem; color: var(--text-mid); line-height: 1.6; }

/* CTA */
#landing-root .cta-final { background: linear-gradient(135deg, var(--blue-dark), var(--blue-mid)); padding: 4rem 1.5rem; text-align: center; }
#landing-root .cta-final h2 { font-size: clamp(1.7rem,5vw,2.8rem); font-weight: 900; color: #fff; margin-bottom: 0.9rem; letter-spacing: -0.02em; }
#landing-root .cta-final p { font-size: 0.93rem; color: rgba(255,255,255,0.75); margin-bottom: 1.8rem; }

/* FOOTER */
#landing-root footer { background: var(--navy); padding: 1.3rem 1.5rem; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 0.8rem; }
#landing-root .foot-logo { display: flex; align-items: center; gap: 8px; font-size: 0.95rem; font-weight: 900; color: #fff; letter-spacing: 0.08em; }
#landing-root .foot-copy { font-size: 0.72rem; color: rgba(255,255,255,0.4); }

/* DESKTOP: 4 why-cards in a row */
@media (min-width: 900px) {
  #landing-root .cards-grid { grid-template-columns: repeat(4,1fr); }
  #landing-root .why-card { padding: 2rem 1.4rem; }
  #landing-root .why-icon { width: 70px; height: 70px; font-size: 1.8rem; }
}

/* TABLET */
@media (max-width: 900px) {
  #landing-root .nav-links { display: none; }
  #landing-root .mockup-inner { grid-template-columns: 1fr; }
  #landing-root .compare-grid { grid-template-columns: 1fr; }
  #landing-root .mockup-section { padding: 2.5rem 1rem; }
  #landing-root .browser { font-size: 90%; }
  #landing-root .testi-grid { grid-template-columns: repeat(2, 1fr); }
  #landing-root .forwho-grid { grid-template-columns: repeat(2, 1fr); }
}

/* MOBILE */
@media (max-width: 560px) {
  #landing-root .app-layout { max-height: none; }
  #landing-root nav { padding: 0.7rem 1rem; }
  #landing-root .nav-logo-text { font-size: 0.9rem; }
  #landing-root .nav-cta { display: none; }
  #landing-root .nav-login { padding: 0.4rem 0.9rem; font-size: 0.8rem; }
  #landing-root .cars-scene { gap: 0; padding: 0 0.3rem; }
  #landing-root .car-card { padding: 0.8rem 0.5rem; border-radius: 12px; }
  #landing-root .car-label { font-size: 0.55rem; }
  #landing-root .car-plate { font-size: 0.65rem; padding: 2px 6px; }
  #landing-root .car-status { font-size: 0.58rem; padding: 2px 6px; }
  #landing-root .arrow-wrap svg { width: 30px; }
  #landing-root .cards-grid { grid-template-columns: 1fr 1fr; gap: 0.8rem; }
  #landing-root .why-card { padding: 1.4rem 1rem; }
  #landing-root .why-icon { width: 56px; height: 56px; font-size: 1.4rem; }
  #landing-root .features-list { grid-template-columns: 1fr; }
  #landing-root .testi-grid { grid-template-columns: 1fr; }
  #landing-root .forwho-grid { grid-template-columns: 1fr; }
  #landing-root .compare-grid { grid-template-columns: 1fr; }
  #landing-root footer { flex-direction: column; align-items: flex-start; }
}

/* SCROLL ANIMATIONS */
#landing-root .anim-fade-up {
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.55s ease, transform 0.55s ease;
}
#landing-root .anim-fade-up.is-visible {
  opacity: 1;
  transform: translateY(0);
}
#landing-root .delay-1 { transition-delay: 0.12s; }
#landing-root .delay-2 { transition-delay: 0.24s; }
#landing-root .delay-3 { transition-delay: 0.36s; }

@media (prefers-reduced-motion: reduce) {
  #landing-root .anim-fade-up {
    opacity: 1;
    transform: none;
    transition: none;
  }
}

/* DEMO TOAST */
.demo-toast {
  position: fixed;
  bottom: 1.8rem;
  left: 50%;
  transform: translateX(-50%);
  background: #0D2B6B;
  color: #fff;
  padding: 0.9rem 1.6rem;
  border-radius: 50px;
  font-size: 0.88rem;
  font-weight: 500;
  z-index: 9999;
  box-shadow: 0 8px 30px rgba(13,43,107,0.35);
  width: max-content;
  max-width: calc(100vw - 2rem);
  white-space: normal;
  text-align: center;
  animation: toastIn 0.3s ease;
}
@keyframes toastIn {
  from { opacity: 0; transform: translateX(-50%) translateY(12px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}
</style>
